import React from "react";

export default function CodificationSpace () {
    return <span className="c-codification__space"> </span>;
};
